const CAPTCHA_ACTIONS = {
  REGISTRATION_INIT: 'registration-init',
  REGISTRATION_COMPLETE: 'registration-complete',
  SEND_VERIFICATION_SMS: 'send-verification-sms',
  LOGIN_PASSWORD: 'login-password',
  CONTACT_US: 'contact-us',
  CONTACT_US_REALTOR: 'contact-us-realtor',
  CONTACT_US_PROFESSIONAL: 'contact-us-professional',
  REPORT: 'report',
  REPORT_PROPERTY: 'report-property',
  CONTACT_AGENCY: 'contact-agency',
  CONTACT_AGENCY_COMMUNITY: 'contact-agency-community',
  CONTACT_PROPERTY_OWNER: 'contact-property-owner',
  PROPERTY_LEAD: 'property-lead'
};

export default CAPTCHA_ACTIONS;
